var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{class:['overflow-hidden text-xs flex bg-shades-lighter h-3 rounded-lg', _vm.variant]},[_c('div',{class:[
        'shadow-none flex flex-col text-center whitespace-nowrap justify-center progress progress-bar',
        _vm.variant ],style:({ width: (_vm.progress + "%") })})])])}
var staticRenderFns = []

export { render, staticRenderFns }